


<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="首次课数量" name="first">
            <firstComponents v-if="activeName === 'first'" ref="firstChart" :translate="translate"></firstComponents>
        </el-tab-pane>
        <el-tab-pane label="首次课成功率" name="second">
            <secondComponents v-if="activeName === 'second'"  ref="secondChart" :translate="translate"></secondComponents>
        </el-tab-pane>


        <!-- <el-tab-pane label="首次课" name="1">
           首次课
        </el-tab-pane>
        <el-tab-pane label="新增率" name="2">
           新增率
        </el-tab-pane>
        <el-tab-pane label="到课率" name="3">
           到课率
        </el-tab-pane>
        <el-tab-pane label="取消率" name="4">
           取消率
        </el-tab-pane>
         <el-tab-pane label="流失率" name="5">
           流失率
        </el-tab-pane> -->

    </el-tabs>
  </div>
</template>



<script>

import firstComponents from './first.vue';
import secondComponents from './second.vue';

export default {
  name: 'firstClassChart',
  components: {
    firstComponents,
    secondComponents,
  },
  data() {
    return {
        activeName: 'first',
        translate: null,
    }
  },

  computed: {
   
  },

  mounted() {

  },

  methods: {
    handleClick(e){
        this.activeName = e.name;
        this.translate = e;

        if (e.name === 'first') {
            this.$nextTick(() => {
              this.$refs.firstChart && this.$refs.firstChart.initCharts && this.$refs.firstChart.initCharts();
            });
        }
        if (e.name === 'second') {
            this.$nextTick(() => {
              this.$refs.secondChart && this.$refs.secondChart.initCharts && this.$refs.secondChart.initCharts();
            });
        }
    },

  },


}


</script>




<style  scoped>


</style>




// WEBPACK FOOTER //
// src/courseConsumptionChart/firstClassChart.vue